<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';

// Valor do operador "Está entre": ['AAAA-MM-DD', 'AAAA-MM-DD'], sempre emitido inteiro.
const range = defineModel({ type: Array, required: true });

const { t } = useI18n();

const updateEnd = (index, value) => {
  const next = [range.value[0] ?? '', range.value[1] ?? ''];
  next[index] = value;
  range.value = next;
};
</script>

<template>
  <div class="flex gap-2">
    <Input
      :model-value="range[0] ?? ''"
      type="date"
      class="[&>input]:h-8 [&>input]:py-1.5 [&>input]:outline-offset-0"
      :placeholder="t('FILTER.DATE_RANGE.START_PLACEHOLDER')"
      @update:model-value="value => updateEnd(0, value)"
    />
    <Input
      :model-value="range[1] ?? ''"
      type="date"
      class="[&>input]:h-8 [&>input]:py-1.5 [&>input]:outline-offset-0"
      :placeholder="t('FILTER.DATE_RANGE.END_PLACEHOLDER')"
      @update:model-value="value => updateEnd(1, value)"
    />
  </div>
</template>
